import React, { useState } from "react";
import { TextField } from "@mui/material";
import AuthenticationWrapper from "../../../../auth/AuthenticationWrapper";

type EditStringProps = {
  value: string;
  onChange: (newValue: string) => void;
  label: string;
  permissionKey?: string;
};

export function useStringInput(instance: any, setInstance: any, key: any) {
  return {
    label: key,
    value: instance?.[key],
    onChange: (newValue: any) => {
      if (newValue !== instance?.[key]) {
        const newInstance = Object.assign(Object.create(instance), instance);
        newInstance[key] = newValue;
        setInstance(newInstance);
      }
    },
  };
}

function EditString(props: EditStringProps) {
  const [value, setValue] = useState(props.value);

  const getComponent = (write: boolean) => (
    <TextField
      disabled={!write}
      label={props.label}
      onBlur={() => {
        props.onChange(value);
      }}
      onChange={(e) => {
        setValue(e.target.value);
      }}
      size={"small"}
      type={"text"}
      value={value}
      variant={"outlined"}
    />
  );

  if (props.permissionKey) {
    return (
      <AuthenticationWrapper
        child={(write: boolean) => {
          return getComponent(write);
        }}
        permissionKey={props.permissionKey}
      />
    );
  } else {
    return getComponent(true);
  }
}

export default EditString;
